/** @format */

import Button from "@mui/material/Button";
import { CsvBuilder } from "filefy";

const DownloadButton = ({ rows, columns, filename }: any) => {
  const downloadCSV = () => {
    const filteredRows = rows.map((row: any) => {
      let rowCopy = { ...row };
      rowCopy.line_items = JSON.stringify(rowCopy.lineItem);
      return Object.values(rowCopy);
    });
    new CsvBuilder(filename)
      .setColumns(columns)
      .addRows(Object.values(filteredRows))
      .exportFile();
  };

  return (
    <Button
      size="small"
      sx={{
        paddingLeft: `30px`,
        paddingRight: `30px`,
        height: `50px`,
        borderRadius: `50px`,
        textTransform: `inherit`,
        backgroundColor: "#FEB127",
        marginLeft:'20px',
        font: `normal normal 500 20px/80px Raleway`,
        "&:hover, &:active": {
          backgroundColor: "#FEB127",
          color: "#fff",
        },
      }}
      variant="contained"
      onClick={downloadCSV}
    >
      Download
    </Button>
  );
};

export default DownloadButton;
